export const LOGO_URL =
  "https://pevbackend.codovio.com/public/uploads/client_logos";
export const RECEIPT_IMG =
  "https://pevbackend.codovio.com/public/uploads/receipt_logos";
export const TICKET_IMG =
  "https://pevbackend.codovio.com/public/uploads/ticket_logos";
export const PROFILE_PICTURE_URL =
  "https://pevbackend.codovio.com/public/uploads/profile_pictures";
export const CHECK_IN_PHOTO =
  "https://pevbackend.codovio.com/public/uploads/checkin_photos";
export const VAPIDKEY = "BJyo7Gej1zE3vlOcUHb2-NtsWGercAyDo7ZsqnSbL7pS-IFIFY1a3-P0Fup2n2Y8FhfM5j7eepXGNxOPcmjIUTY"


